import { useState } from 'preact/hooks';
import { refresh, setToken } from '../app/store.ts';

/** One-time token gate; the token lives in localStorage and rides x-admin-token. */
export function TokenPrompt() {
  const [value, setValue] = useState('');

  const submit = (e: Event) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    setToken(trimmed);
    void refresh();
  };

  return (
    <div class="token-gate">
      <form class="token-form" onSubmit={submit}>
        <h1>Accreto Admin</h1>
        <p>Enter the admin token (same value as the Fly `ADMIN_TOKEN` secret).</p>
        <input
          type="password"
          value={value}
          onInput={(e) => setValue((e.target as HTMLInputElement).value)}
          placeholder="admin token"
          autofocus
        />
        <button type="submit">Unlock</button>
      </form>
    </div>
  );
}
